import { InformationCircleIcon } from "@heroicons/react/24/solid";
import type { ReactNode } from "react";

export default function InfoBox({
  children,
  Icon,
}: {
  children: ReactNode;
  Icon?: React.ComponentType<{ className?: string }>;
}) {
  return (
    <div className="p-3 bg-muted text-muted-foreground flex gap-3">
      {Icon ? (
        <Icon className="h-5 flex-shrink-0" />
      ) : (
        <InformationCircleIcon className="h-5 flex-shrink-0" />
      )}

      <div>{children}</div>
    </div>
  );
}
